export enum RefetchIntervals {
  NORMAL = 5000,
  FAST = 2000,
}
